
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"17","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"width":"17","height":"17","rx":"8.5","fill":"#282830","opacity":".8"}}),_c('path',{attrs:{"d":"M5.844 5.844l5.312 5.312M11.156 5.844l-5.312 5.312","stroke":"#fff","stroke-width":"1.5","stroke-linejoin":"round"}})])
      }
    
      }
    